import { DragEvent, ReactNode, useState } from 'react';
import { IconUpload } from '@components/icons';
import classNames from 'classnames';

interface ImageGalleryEmptyProps {
  title: ReactNode;
  subtitle: string;
  onClick: () => void;
  onFileDropped: (file: File) => void;
  isUploading?: boolean;
}

export const ImageGalleryEmpty = ({
  title,
  subtitle,
  onClick,
  onFileDropped,
  isUploading = false,
}: ImageGalleryEmptyProps) => {
  const [isDragOver, setIsDragOver] = useState(false);

  const handleDragOver = (e: DragEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setIsDragOver(true);
  };

  const handleDragLeave = (e: DragEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setIsDragOver(false);
  };

  const handleDrop = (e: DragEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setIsDragOver(false);
    const file = e.dataTransfer.files[0];
    if (file) onFileDropped(file);
  };

  if (isUploading) {
    return (
      <div
        data-testid='image-gallery__empty-skeleton'
        className='w-full rounded-sm border border-dashed border-soft fill-secondary-active animate-pulse h-[100px]'
      />
    );
  }

  return (
    <button
      type='button'
      onClick={onClick}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      data-testid='image-gallery__empty-dropzone'
      className={classNames(
        'w-full rounded-sm border border-dashed border-soft py-6 px-4 flex flex-col items-center justify-center gap-2 transition-colors',
        {
          'fill-primary': !isDragOver,
          'bg-tertiary': isDragOver,
        }
      )}>
      <IconUpload className='w-6 h-6 text-primary' />
      <span className='block text-center text-body-s text-primary'>{title}</span>
      <span className='block text-center text-body-xs text-secondary'>{subtitle}</span>
    </button>
  );
};
